// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__Hjw5t","modalBody":"MealsPop_modalBody__MDaVV"};